import { Link } from 'react-router-dom';
import './services.css';
import Header from '../components/Navbar/Navbar.js';
import Footer from '../components/Footer/Footer.js';
import Seo from '../components/Seo';
import { images } from '../config/imagePaths';

const services = [
  {
    to: '/public-speaking',
    title: 'Public Speaking',
    text: 'Transform how you communicate and present with confidence, clarity, and impact.',
    image: images.services.publicSpeaking,
    alt: 'A speaker presenting to an audience',
  },
  {
    to: '/digital-marketing',
    title: 'Digital Marketing',
    text: 'Unlock effective online strategies to boost your visibility and engage your audience.',
    image: images.services.marketingHero,
    alt: 'Digital marketing content being created',
  },
  {
    to: '/web-design',
    title: 'Web Design',
    text: 'Build a compelling online presence with beautiful, functional websites.',
    image: images.services.webDesignHero,
    alt: 'A laptop displaying a website design',
  },
];

function Services() {
  return (
    <div className="services-listing-page">
      <Seo
        title="Services"
        description="Explore AOK Communications services: public speaking, digital marketing, and web design."
      />
      <Header />

      <main className="services-listing-main page-content">
        <header className="services-intro reveal">
          <span className="services-eyebrow">Our Services</span>
          <h1>How we help you grow</h1>
          <p>
            From the stage to the screen, we equip you with the tools to communicate
            clearly and reach the people who matter most.
          </p>
        </header>

        <div className="services-rows">
          {services.map((service, i) => (
            <Link
              to={service.to}
              key={service.to}
              className={`service-row hover-lift ${i % 2 === 1 ? 'reverse reveal-right' : 'reveal-left'}`}
            >
              <div className="service-row-image img-zoom-wrap">
                <img src={service.image} alt={service.alt} />
              </div>
              <div className="service-row-text">
                <h2>{service.title}</h2>
                <p>{service.text}</p>
                <span className="service-row-link">Explore &rarr;</span>
              </div>
            </Link>
          ))}
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default Services;
